module.exports = "https://img1.huilianyi.com/8/icon-mail.85e05e9ad6.appcore.png";